import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, message, Modal, Input, List, Avatar, Typography, Collapse } from "antd";
import {
  createIdeProject,
  createFileOrFolder,
  getIdeProjects,
} from "../../services/ide-apis";
import { global_var } from "../../services/cs-lab-config";
import {
  getIdeProjectLogo,
  getIdeProjectRoute,
  getIdeProjectTypeMetaData,
  trackEvent,
} from "../utils/util-functions";

const { Panel } = Collapse;

const CreateIDEProjectModal = (props) => {
  const [newProjectModal, setNewProjectModal] = useState(true);
  const [ideProjectCreatingProgress, setIdeProjectCreatingProgress] =
    useState(false);

  const [newProjectName, setNewProjectName] = useState("");
  const [ideProjects, setIdeProjects] = useState("");

  const [collapseVisible ] = useState(false);


  const navigate = useNavigate();
  const MAX_LENGTH = 60;

  function handleNewProject() {
    if (newProjectName.trim() === "") {
      message.error("Please enter a valid project name");
      return;
    }
    if (newProjectName.length > MAX_LENGTH) {
      message.error(`The file name exceeds the maximum allowed limit. Use a shorter name`);
      return;
    }

    trackEvent("new_project_create_button_clicked", {
      ide_project_stack_name: props.projectStack,
    });

    setIdeProjectCreatingProgress(true);

    createIdeProject(newProjectName, props.projectStack).then((response) => {
      setIdeProjectCreatingProgress(false);

      response = response.data;

      if (response.statusCode === 200) {
        message.success(response.message);

        setIdeProjectCreatingProgress(true);

        // Create a file by default when creating project
        createFileOrFolder(response.ideProjectId, {
          fileOrFolderObject: {
            fileName: getIdeProjectTypeMetaData(props.projectStack)
              .defaultFileName,
            isFile: true,
            path: "",
          },
        }).then((fileResponse) => {
          setIdeProjectCreatingProgress(false);
          fileResponse = fileResponse.data;

          if (fileResponse.statusCode === 200) {
            message.success(fileResponse.message);
            navigate(
              getIdeProjectRoute(props.projectStack) + response.ideProjectId
            );
            setNewProjectModal(false);
          } else {
            message.error(fileResponse.message);
            navigate(
              getIdeProjectRoute(props.projectStack) + response.ideProjectId
            );
            setNewProjectModal(false);
          }
        });
      } else {
        message.error(response.message);
      }
    });
  }

  useEffect(() =>{
    getIdeProjects({
      projectLanguage: props.projectStack,
      userLoginId: global_var.user_login_id,
    }).then((response) => {
      response = response.data;
      setIdeProjects(response)
    })
  },[props.projectStack])

  const handleRecentProjectOpen = (projectId) => (e) => {
    trackEvent("ide_recent_project_opened", {
      ide_project_stack_name: props.projectStack,
    });

    setNewProjectModal(false);
    Modal.destroyAll();
    navigate(getIdeProjectRoute(props.projectStack) + projectId);
  };

  return (
    <Modal
      title={
        <span style={{ fontSize: '24px', fontWeight:'bold' }}>
          {"Create " +
            getIdeProjectTypeMetaData(props.projectStack).projectStackDisplayName +
            " Project"}
        </span>
      }
      centered
      open={newProjectModal}
      onOk={() => setNewProjectModal(false)}
      onCancel={() => {
        setNewProjectModal(false);
        navigate("/");
      }}
      closable={true}
      maskClosable={false}
      keyboard={false}
      footer={[
        <Button
        className="cancel-button"
          key="cancel_button"
          disabled={ideProjectCreatingProgress}
          onClick={() => navigate("/")}
        >
          Cancel
        </Button>,
        <Button
          style={{color:'#fff',borderColor: "#E96358"}}
          className="create-button"
          key="create_button"
          loading={ideProjectCreatingProgress}
          onClick={handleNewProject}
        >
          Create
        </Button>,
        <div  style={{ textAlign: 'left' }}>
          <Collapse className={collapseVisible ? "collapse-visible" : "collapse-hidden"}>
            <Panel header="Open Recent Projects" key="1">
              <div>
                <List
                style={{ maxHeight: '300px', overflowY: 'auto', overflowX: 'hidden', width: '100%'}}
                itemLayout="horizontal"
                dataSource={ideProjects.projects} 
                renderItem={(project) => (
                  <List.Item>
                    <List.Item.Meta
                      avatar={
                        <Avatar src={getIdeProjectLogo(props.projectStack)} />
                      }
                      title={
                        <Typography.Link
                          onClick={handleRecentProjectOpen(project._id)}
                        >
                          {project.name}
                        </Typography.Link>
                      }
                    />
                  </List.Item>
                )}
              />
              </div>
            </Panel>
          </Collapse>
      </div>
      ]}
    >
      <Input
        size="large"
        placeholder="Enter project name"
        onChange={(e) => setNewProjectName(e.target.value)}
        className="mb-2"
        maxLength={MAX_LENGTH}
      />
    </Modal>
  );
};

export default CreateIDEProjectModal;
